module.exports = __webpack_public_path__ + "img/28800.bf8c5ce4.jpg";